import { AxiosInstance } from 'axios';

let csrfToken: string | undefined;
export const injectCsrfTokenForInterceptor = (newCsrfToken: string | undefined) => (csrfToken = newCsrfToken);

/**
 * Inject a `csrf` header into every request
 */
export const addCsrfToRequests = (client: AxiosInstance) => {
  client.interceptors.request.use(config => ({
    ...config,
    headers: {
      ...config.headers,
      'X-CSRF-TOKEN': csrfToken
    }
  }));
};
